import { Edit } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { DireccionesContext } from '../../pages/catalogos/DireccionesPage'

export const TablaDireccionComponent = ({direccion}) => {
  const {setEditandoDireccion, setModalAgregaDireccion, setDireccionSeleccionada} = useContext(DireccionesContext);

  return (
    <>
        <Typography style={{fontSize:14, fontWeight:'',flex:15}} >{direccion?.direccion}</Typography>
        <Typography style={{fontSize:14, fontWeight:'',flex:15}}>{direccion?.nombreCorto}</Typography>
        <Typography style={{fontSize:14, fontWeight:'',flex:15}}>{direccion?.responsable}</Typography>
        <Typography style={{fontSize:14, fontWeight:'',flex:5, flexDirection:'row', justifyContent:'flex-end'}}>
            <Button
              onClick={() => { setEditandoDireccion(true); setModalAgregaDireccion(true);setDireccionSeleccionada(direccion)}}
            >
              <Edit />
            </Button >
          </Typography>
    </>
  )
}
